<template>
    <div>
        <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
        <iotInsightsTab />
        <Filter />
        <div class="container-fluid iot-dashboard-content px-0">
            <div class="grid-item deviceStatus">
                <deviceStatus />
            </div>
            <div class="grid-item device">
                <device />
            </div>
            <!-- <div class="grid-item deviceAnalysis deviceAnalysisCurrent"><deviceAnalysisCurrent/></div> -->
            <!-- <div class="grid-item deviceAnalysis deviceAnalysisFuture"><deviceAnalysisFuture/></div> -->
        </div>
    </div>

</template>
<script>
import Header from '@/components/Header.vue';
import Filter from '@/components/Filter.vue';
import deviceStatus from './device-status.vue';
import device from './device.vue';
import iotInsightsTab from '@/components/iot-insights-tab.vue';
//    import deviceAnalysisCurrent from './device-analysis-current.vue';
//    import deviceAnalysisFuture from './device-analysis-future.vue';
export default {
    name: "iot",
    components: {
        Header,
        Filter,
        deviceStatus,
        device,
        iotInsightsTab
        // deviceAnalysisCurrent,
        // deviceAnalysisFuture
    },
    data() {
        return {
            breadcrumsfirst: "Dashboard",
            breadcrumslast: "IoT Insights",
        }
    }
}
</script>
<style></style>